var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "complete",
      attrs: {
        "hide-footer": "",
        title: _vm.$t(_vm.type + ".title"),
        "hide-header-close": ""
      }
    },
    [
      _c("div", [
        _vm._v(
          "\n  " +
            _vm._s(
              _vm.$t(_vm.type + ".content", {
                systemtype: _vm.$t(
                  "systemtypes." + this.system.SystemPartNumber
                ),
                serialnumber: this.system.SerialNumber,
                location: this.system.Location
              })
            ) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "b-form-checkbox",
        {
          staticClass: "pt-4",
          attrs: {
            "aria-describedby": "send mail",
            "aria-controls": "send mail"
          },
          model: {
            value: _vm.sendByMail,
            callback: function($$v) {
              _vm.sendByMail = $$v
            },
            expression: "sendByMail"
          }
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t(_vm.type + ".checkbox")) +
              " " +
              _vm._s(_vm.email) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "b-btn",
        {
          staticClass: "mt-3",
          attrs: { block: "", variant: "outline-success" },
          on: { click: _vm.ok }
        },
        [_vm._v(_vm._s(_vm.$t("buttons.ok")))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33b94078", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33b94078","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./WebApp/components/modals/SendConfigByMailModal.vue
// module id = 771
// module chunks = 0